export default "__VITE_ASSET__B3r3Z7yc__"